import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'
import i18n from '../../../i18n'

import { GetResponseLinksTypeOptionValue } from './TableExportGetResponseLinkTypeModal.constants'

export function getOptions() {
  return [
    {
      id: GetResponseLinksTypeOptionValue.Later,
      label: i18n.t('Modal.ExportGetFilesLaterOptionKey'),
    },
    {
      id: GetResponseLinksTypeOptionValue.Wait,
      label: i18n.t('Modal.ExportWaitForFilesOptionKey'),
    },
  ]
}

export function getFileDirectoryLink({ directoryId, isDwellerUser }) {
  return isDwellerUser
    ? `/${WEBAPP_ROUTE_PREFIX}/dweller-files/${directoryId}`
    : `/files/dir/${directoryId}`
}
